export const TYPE_OPTIONS = ["Component Volume", "Total Volume"];

export const COMPOUND_OPTIONS = ["Yes", "No"];
